@import "../../theme/global";

.content {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 15rem;
  padding: 2rem;

  @media (max-width: 576px) {
    min-height: 12rem;
  }
}